import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const navItems = [
  {
    path: '/cases',
    label: 'All Cases',
    exact: true,
    icon: (
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
          d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
      </svg>
    ),
  },
  {
    path: '/cases/new',
    label: 'New Case',
    exact: true,
    icon: (
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
          d="M12 4v16m8-8H4" />
      </svg>
    ),
  },
];

/**
 * CasesModuleNav – horizontal sub-navigation bar for the Cases module.
 * Accepts optional counts for open/active cases to display as badges.
 */
const CasesModuleNav = ({ openCount = 0, activeCount = 0 }) => {
  const location = useLocation();

  const isActive = (item) => {
    if (item.exact) return location.pathname === item.path;
    return location.pathname.startsWith(item.path);
  };

  return (
    <nav
      className="flex items-center gap-1 mb-6 bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 shadow-sm p-1"
      aria-label="Cases module navigation"
    >
      {navItems.map((item) => {
        const active = isActive(item);
        const showOpenBadge = item.path === '/cases' && item.exact && openCount > 0;
        const showActiveBadge = item.path === '/cases' && item.exact && activeCount > 0;

        return (
          <Link
            key={item.path}
            to={item.path}
            className={`relative flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
              active
                ? 'bg-primary-600 text-white shadow-sm'
                : 'text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 hover:text-gray-900 dark:hover:text-white'
            }`}
            aria-current={active ? 'page' : undefined}
          >
            {item.icon}
            {item.label}
            {showOpenBadge && (
              <span
                className="ml-1 inline-flex items-center justify-center min-w-[1.25rem] h-5 px-1 text-xs font-bold rounded-full bg-blue-500 text-white"
                title={`${openCount} open case${openCount !== 1 ? 's' : ''}`}
              >
                {openCount}
              </span>
            )}
            {!showOpenBadge && showActiveBadge && (
              <span
                className="ml-1 inline-flex items-center justify-center min-w-[1.25rem] h-5 px-1 text-xs font-bold rounded-full bg-green-500 text-white"
                title={`${activeCount} active case${activeCount !== 1 ? 's' : ''}`}
              >
                {activeCount}
              </span>
            )}
          </Link>
        );
      })}
    </nav>
  );
};

export default CasesModuleNav;
